module.exports = __webpack_public_path__ + "media/bg.7962d09a.ogg";